import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@CONTEXTS";
import {
  Descriptions,
  Switch,
  Form,
  Spin,
  message,
  Button,
  Tooltip,
} from "antd";
import { updateCompanySettings } from "@SETTINGS";
import { useHistory } from "react-router";
import { useAuthority } from "@HOOKS";

const Informations = () => {
  const [form] = Form.useForm();
  const { info } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const canCreateReturnedDelivery = useAuthority("CREATE_RETURNED_DELIVERY");

  useEffect(() => {
    form.setFieldsValue({
      autoPackage: info.autoPackage,
      autoDeliveryNumber: info.autoDeliveryNumber,
      recall: info.recall,
      autoAdvanceReturnedDate: info.autoAdvanceReturnedDate,
      productSelection: info.productSelection,
    });
  }, []);
  const handleSave = () => {
    form.validateFields().then(async (values) => {
      setLoading(true);

      const response = await updateCompanySettings(values);

      if (response?.success) {
        //Ayarlar contexte yazılabilmesi için sayfayı yeniliyoruz.
        history.go(0);
      } else {
        console.log(response);
        message.error({
          content: response?.error?.msg || "",
          className: "app-error-message",
        });
        form.setFieldsValue({ autoPackage: false });
      }

      setLoading(false);
    });
  };

  return (
    <>
      <Spin spinning={loading}>
        <Form layout="vertical" form={form}>
          <Descriptions
            title={"Ayarlar"}
            bordered
            layout="horizontal"
            column={1}
          >
            <Descriptions.Item
              label={
                <h3>Gönderi Sipariş Numarası Sistem Tarafından Oluşturulsun</h3>
              }
              span={1}
            >
              <Form.Item
                name="autoDeliveryNumber"
                label=""
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Descriptions.Item>
            <Descriptions.Item
              label={<h3>Oluşturulan Gönderiler Otomatik Paketlensin</h3>}
              span={1}
            >
              <Form.Item name="autoPackage" label="" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Descriptions.Item>
            {info?.canRecall && (
              <Descriptions.Item
                label={
                  <Tooltip
                    title={
                      "Bu ayar, teslim alınan kargolar henüz dağıtıma çıkmamışsa geri çağırma yetkisini aktif hale getirir."
                    }
                    placement="bottomLeft"
                  >
                    <h3>Gönderi Geri Çağırma</h3>
                  </Tooltip>
                }
                span={1}
              >
                <Form.Item name="recall" label="" valuePropName="checked">
                  <Switch />
                </Form.Item>
              </Descriptions.Item>
            )}
            {canCreateReturnedDelivery && (
              <Descriptions.Item
                label={<h3>Randevulu İade tarihi otomatik ilerlesin.</h3>}
                span={1}
              >
                <Form.Item
                  name="autoAdvanceReturnedDate"
                  label=""
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Descriptions.Item>
            )}
            {/*!info?.isSelectionRequired && (
              <Descriptions.Item
                label={
                  <h3>Gönderi eklerken malzeme/ürün seçimi yapılabilsin</h3>
                }
                span={1}
              >
                <Form.Item
                  name="productSelection"
                  label=""
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Descriptions.Item>
            )*/}
          </Descriptions>

          <Button
            type="primary"
            style={{ float: "right", marginTop: 16 }}
            onClick={() => handleSave()}
          >
            Kaydet
          </Button>
        </Form>
      </Spin>
    </>
  );
};

export default Informations;
